import { Box, Button, CardContent, CardHeader, Grid, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { apiConstants, get } from '../../common/constants'
import * as React from 'react'
import { useParams } from "react-router";
import { FormProvider, RHFSelectField } from "../../common/hook-form";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from 'yup';
import { DownloadExcelMultipleSheets } from "../../helpers/ExcelGenerator";
import { formatCurrency } from "../../helpers/UtilityHelper";
import _ from "lodash";
import ProzoDataGrid from "../../common/ProzoDataGrid";

const columns = [
    {
        field: 'zoneName',
        headerName: 'Zone',
        width: 120,
        renderCell: (col) => {
            return col.row.zoneKey || col.row.zoneName || col.row.zone || '-'
        }
    },
    {
        field: 'startWt',
        headerName: 'Start Weight (gm)',
        width: 150,
        renderCell: (col) => {
            return col.row.slab[0].startWt
        }
    },
    {
        field: "maxWt",
        headerName: "Max weight (gm)",
        width: 150,
        renderCell: (col) => {
            return col.row.slab[0].maxWt
        }


    },
    {
        field: 'price',
        headerName: 'Price',
        width: 100,
        renderCell: (col) => {
            return (col.row.slab[0].price ? ("₹ " + col.row.slab[0].price) : "-")
        }

    },
    {
        field: 'additionalUnit',
        headerName: 'Additional Unit(gm)',
        width: 100,
        renderCell: (col) => {
            return (col.row.slab[0].additionalUnit)
        }
    },
    {
        field: 'additionalUnitRate',
        headerName: 'Additional Unit Rate',
        width: 100,
        renderCell: (col) => {
            return (col.row.slab[0].additionalUnitRate)
        }
    },
    {
        field: 'volumetricCoeff',
        headerName: 'Volumetric Coefficient ',
        width: 100,
        renderCell: (col) => {
            return (col.row.slab[0].volumetricCoeff)
        }
    },
    {
        field: 'taxPercent',
        headerName: 'Tax',
        width: 100,
        renderCell: (col) => {
            return (col.row.slab[0].taxPercent ? (col.row.slab[0].taxPercent + " %") : "-")
        }
    },
    {
        field: 'surchargePercent',
        headerName: 'Surcharge %',
        width: 110,
        renderCell: (col) => {
            return (col.row.slab[0].surchargePercent ? (col.row.slab[0].surchargePercent + " %") : "-")
        }
    },
    {
        field: 'docketCharge',
        headerName: 'Docket Charge',
        width: 110,
        renderCell: (col) => {
            return (col.row.slab[0].docketCharge)
        }
    },
    // {
    //     field: 'invoicePercentCOD',
    //     headerName: 'Invoice Percentage for COD %',
    //     width: 130,
    //     renderCell: (col) => {
    //         return (col.row.slab[0].invoicePercentCOD ? (col.row.slab[0].invoicePercentCOD + " %") : "-")
    //     }
    // },
    {
        field: 'codOperator',
        headerName: 'COD Operator',
        width: 110,
        renderCell: (col) => {
            return (col.row.slab[0].codOperator)
        }
    },
    {
        field: 'minChargableAmount',
        headerName: 'Min chargable amount',
        width: 110,
        renderCell: (col) => {
            return (col.row.slab[0].minChargableAmount)
        }
    },
    {
        field: 'minChargableWeight',
        headerName: 'Min chargable Weight',
        width: 110,
        renderCell: (col) => {
            return (col.row.slab[0].minChargableWeight)
        }
    },
    {
        field: 'appointmentDelChargesPerKg',
        headerName: 'Appointment Delivery Charge Per Kg',
        width: 110,
        renderCell: (col) => {
            return (col.row.slab[0].appointmentDelChargesPerKg)
        }
    },
    {
        field: 'appointmentDelChargesMin',
        headerName: 'Appointment Delivery Charge Min',
        width: 110,
        renderCell: (col) => {
            return (col.row.slab[0].appointmentDelChargesMin)
        }
    },
    {
        field: 'oda1PerKg',
        headerName: 'ODA1 Per Kg',
        width: 110,
        renderCell: (col) => {
            return (col.row.slab[0].oda1PerKg)
        }
    },
    {
        field: 'oda2PerKg',
        headerName: 'ODA2 Per Kg',
        width: 110,
        renderCell: (col) => {
            return (col.row.slab[0].oda2PerKg)
        }
    },
    {
        field: 'oda3PerKg',
        headerName: 'ODA3 Per Kg',
        width: 110,
        renderCell: (col) => {
            return (col.row.slab[0].oda3PerKg)
        }
    },
    {
        field: 'odaMin',
        headerName: 'ODA Min',
        width: 110,
        renderCell: (col) => {
            return (col.row.slab[0].odaMin)
        }
    },
    {
        field: 'fovORPerInv',
        headerName: 'FOV (OR) INV%',
        width: 110,
        renderCell: (col) => {
            return (col.row.slab[0].fovORPerInv ? col.row.slab[0].fovORPerInv + " %" : '-')
        }
    },
    {
        field: 'fovORMin',
        headerName: 'FOV (OR) Min',
        width: 110,
        renderCell: (col) => {
            return (col.row.slab[0].fovORMin)
        }
    },
    {
        field: 'boxHandlingChargableWt',
        headerName: 'Box Handling Chargable Weight',
        width: 110,
        renderCell: (col) => {
            return (col.row.slab[0].boxHandlingChargableWt)
        }
    },
    {
        field: 'boxHandlingMin',
        headerName: 'Box Handling Min Charge',
        width: 110,
        renderCell: (col) => {
            return (col.row.slab[0].boxHandlingMin)
        }
    },
    {
        field: 'maxDamLossLiability',
        headerName: 'Max Damage/Lost liability',
        width: 110,
        renderCell: (col) => {
            return (col.row.slab[0].maxDamLossLiability)
        }
    },
    {
        field: 'minTat',
        headerName: 'B2B Min TAT',
        width: 100,

    },
    {
        field: 'maxTat',
        headerName: 'B2B Max TAT',
        width: 100,

    },
    // {
    //     field: 'tatUnit',
    //     headerName: 'TAT Unit',
    //     width: 100,

    // },
    {
        field: 'rtoPercentOfForward',
        headerName: 'RTO (Forward %)',
        width: 100,
        renderCell: (col) => {
            return (col.row.slab[0].rtoPercentOfForward ? (col.row.slab[0].rtoPercentOfForward + " %") : "-")
        }
    },
]



function B2bRateCard({ courier }) {
    const { id } = useParams();
    const [price, setPrice] = useState([]);
    const [response, setResponse] = useState([]);
    const [allrate, setAllRate] = useState([])
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [sizePerPage, setSizePerPage] = useState(20);

    const Region = ["B2B"];

    const method = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                ZoneName: Yup.string().required("Please select zone"),
                CourierPartner: Yup.string().required("Please select courier"),
            })
        ),
        defaultValues: {
            ZoneName: '',
            CourierPartner: ''
        }
    });
    const {
        handleSubmit,
        watch,
        reset,
    } = method;
    const courierName = watch("CourierPartner")
    const selectedZone = watch("ZoneName");

    async function onSubmit(data) {
    }

    async function fetchPriceData(courier, zone) {
        if (courier) {
            if (zone) {
                const selectedRate = response.find((item) => (
                    item.cplist.includes(courier) && zone in item.sla
                ));
                if (selectedRate) {
                    const priceData = selectedRate.sla[zone];
                    setPrice([priceData]);
                } else {
                    setPrice([]);
                }
            } else {
                const selectedRate = response.find((item) => item.cplist.includes(courier));
                if (selectedRate) {
                    const allZonesData = Object.entries(selectedRate.sla).map(([zoneKey, zoneData]) => ({
                        ...zoneData,
                        zoneKey: zoneKey,
                        id: `zone_${zoneKey}_${Date.now()}`
                    }));
                    setPrice(allZonesData);
                } else {
                    setPrice([]);
                }
            }
        }
    }

    useEffect(() => {
        if (courierName) {
            fetchPriceData(courierName, selectedZone);
        }
    }, [courierName, selectedZone]);

    const courierData = response && response?.map((courier) => ({
        label: courier.cplist[0],
        value: courier.cplist[0]
    }))

    const zone = response && response?.length > 0 ? response.filter(val => val.cplist.includes(courierName))[0]?.sla : [];
    const dropdownOptions = zone && Object.keys(zone).map(val => ({
        label: val,
        value: val
    }));

    const zoneOptionsWithAll = courierName ? [
        ...(dropdownOptions || [])
    ] : [];

    useEffect(() => {
        get(`${apiConstants.B2B_RATE_CARD}/?id=${id}&type=merchant`).then((res) => {
            setResponse(res.data)
        }).catch((err) => console.log(err))
    }, [id])



    // full data download
    React.useEffect(() => {
        if (response) {
            const filter = response?.filter((item) => item.active === true)
            let arr2 = [];
            for (let i = 0; i < filter?.length; i++) {
                const cpList = filter[i]?.cplist?.[0] ? filter[i]?.cplist[0] : "";
                const pro = filter[i].sla;
                const convert = Object.entries(pro).map((e) => (e[1]));
                for (let j = 0; j < convert.length; j++) {
                    for (let k = 0; k < Region.length; k++) {
                        if (convert[j].zoneName === Region[k]) {
                            const minTat = convert[j].minTat;
                            const maxTat = convert[j].maxTat;
                            const tatUnit = convert[j].tatUnit
                            let newArr = convert[j].slab.map((item, index) => {
                                courier.map((d) => {
                                    if (cpList === d.prozoId)
                                        item.cp = d.name + " / " + Region[k];
                                    return item;
                                })
                                item.cp = cpList + " / " + Region[k]
                                item.minTat = minTat;
                                item.maxTat = maxTat;
                                item.tatUnit = tatUnit;
                                item.zoneKey = Object.keys(pro)[j];
                                item.zoneName = convert[j].zoneName;

                                return item;
                            })
                            arr2.push(newArr);
                        }
                    }
                }
                let objArray = _.flatten(arr2)
                objArray.map((item, index) => {
                    item.id = Math.random() * 1000;
                    return item
                })
                setAllRate(objArray)
            }
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [courier, response])

    const normalizeDataForExport = (data) => {
        if (!data || data.length === 0) return [];
        return data.map(item => {
            const slabData = item.slab ? item.slab[0] : item;
            return {
                ...item,
                normalizedSlab: slabData
            };
        });
    };


    const sheets = [
        {
            name: "Merchant Rate Card",
            data: normalizeDataForExport(price.length > 0 ? price : allrate),
            columns: [
                {
                    label: 'Zone',
                    value: (col) => col.zoneKey || col.zone || col.zoneName || '-'
                },
                {
                    label: 'Courier Partner',
                    value: (col) => {
                        // Try to get courier partner from different possible sources
                        if (col.slab?.[0]?.cp) {
                            return col.slab[0].cp;
                        } else if (col.cp) {
                            return col.cp;
                        } else if (courierName) {
                            // If no specific courier info, use the selected courier
                            const selectedCourier = courier?.find(c => c.prozoId === courierName);
                            return selectedCourier ? selectedCourier.name : courierName;
                        }
                        return '-';
                    }
                },
                {
                    label: 'Start Weight(gm)',
                    value: (col) => col.normalizedSlab.startWt,
                },
                {
                    label: 'Max Weight(gm)',
                    value: (col) => col.normalizedSlab.maxWt
                },
                {
                    label: 'Price',
                    value: (col) => formatCurrency(col.normalizedSlab.price)
                },
                {
                    label: 'Additional Unit(gm)',
                    value: (col) => (col.normalizedSlab.additionalUnit)
                },
                {
                    label: 'Additional Unit Rate',
                    value: (col) => formatCurrency(col.normalizedSlab.additionalUnitRate)
                },
                {
                    label: 'Volumetric Coefficient',
                    value: (col) => col.normalizedSlab.volumetricCoeff
                },
                {
                    label: 'Tax',
                    value: (col) => col.normalizedSlab.taxPercent ? (col.normalizedSlab.taxPercent + " %") : "-"
                },
                {
                    label: 'Surcharge %',
                    value: (col) => col.normalizedSlab.surchargePercent ? (col.normalizedSlab.surchargePercent + " %") : "-"
                },
                {
                    label: 'Docket Charge',
                    value: (col) => formatCurrency(col.normalizedSlab.docketCharge)
                },
                {
                    label: 'COD Operator',
                    value: (col) => col.normalizedSlab.codOperator
                },
                {
                    label: 'Min chargable amount',
                    value: (col) => formatCurrency(col.normalizedSlab.minChargableAmount)
                },
                {
                    label: 'Min chargable Weight',
                    value: (col) => col.normalizedSlab.minChargableWeight
                },
                {
                    label: 'Appointment Delivery Charge Per Kg',
                    value: (col) => formatCurrency(col.normalizedSlab.appointmentDelChargesPerKg)
                },
                {
                    label: 'Appointment Delivery Charge Min',
                    value: (col) => formatCurrency(col.normalizedSlab.appointmentDelChargesMin)
                },
                {
                    label: 'ODA1 Per Kg',
                    value: (col) => (col.normalizedSlab.oda1PerKg
                    )
                },
                {
                    label: 'ODA2 Per Kg',
                    value: (col) => (col.normalizedSlab.oda2PerKg)
                },
                {
                    label: 'ODA3 Per Kg',
                    value: (col) => col.normalizedSlab.oda3PerKg
                },
                {
                    label: 'ODA Min',
                    value: (col) => formatCurrency(col.normalizedSlab.odaMin)
                },
                {
                    label: 'FOV (OR) INV%',
                    value: (col) => col.normalizedSlab.fovORPerInv ? (col.normalizedSlab.fovORPerInv + " %") : "-"
                },
                {
                    label: 'FOV (OR) Min',
                    value: (col) => col.normalizedSlab.fovORMin
                },
                {
                    label: 'Box Handling Chargable Weight',
                    value: (col) => formatCurrency(col.normalizedSlab.boxHandlingChargableWt)
                },
                {
                    label: 'Box Handling Min Charge',
                    value: (col) => col.normalizedSlab.boxHandlingMin
                },
                {
                    label: 'Max Damage/Lost liability',
                    value: (col) => col.normalizedSlab.maxDamLossLiability
                },
                {
                    label: 'B2B MIN TAT',
                    value: (col) => col.normalizedSlab.b2bTaT?.minTat
                },
                {
                    label: 'B2B MAX TAT',
                    value: (col) => col.normalizedSlab.b2bTaT?.maxTat
                },
                {
                    label: 'RTO (Forward %)',
                    value: (col) => col.normalizedSlab.rtoPercentOfForward ? (col.normalizedSlab.rtoPercentOfForward + " %") : "-"
                },
            ]
        }
    ]


    return (
        <Box>
            <CardHeader title='Merchant Rate Card (B2B)'
                subheader="View pricing details for business shipments, including zone-based rates and courier partner settings."
                action={
                    <DownloadExcelMultipleSheets sheets={sheets} filename="Merchant Rate Card" />
                }
            />
            <CardContent>
                <FormProvider methods={method} onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={2} alignItems="center" paddingBottom={1}>
                        <Grid item xs={4}>
                            <RHFSelectField name="CourierPartner" width="100%" label="Courier Partner" options={courierData || []}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <RHFSelectField name="ZoneName"
                                width="100%"
                                label="Zone Name"
                                disabled={!courierName}
                                options={zoneOptionsWithAll || []}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Button onClick={() => {
                                setPrice([])
                                reset()
                            }}
                                variant="contained"
                                color="error"
                                size="small"
                            >Reset</Button>
                        </Grid>
                    </Grid>
                </FormProvider>
                {price.length > 0 &&
                    <ProzoDataGrid
                        columns={columns}
                        getRowId={(row) => row.id}
                        rows={price ? price : []}
                        autoHeight={true}
                        rowCount={price?.length || Number.MAX_VALUE}
                        pagination={true}
                        paginationMode={'client'}
                        getRowHeight={() => 25}
                        page={page}
                        setPage={setPage}
                        sizePerPage={sizePerPage}
                        setSizePerPage={setSizePerPage}
                    />
                }
            </CardContent>
        </Box >
    );
}


export default B2bRateCard;